import { render, staticRenderFns } from "./auctionPrice.vue?vue&type=template&id=ec1534ea&scoped=true"
import script from "./auctionPrice.vue?vue&type=script&lang=js"
export * from "./auctionPrice.vue?vue&type=script&lang=js"
import style0 from "./auctionPrice.vue?vue&type=style&index=0&id=ec1534ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1534ea",
  null
  
)

export default component.exports